import { Controller } from "stimulus";
import EmblaCarousel from "embla-carousel";

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 4000 },
  };

  connect() {
    this.container = this.element.querySelector(".trial-activity-list");
    if (!this.container) return;

    this.duplicateSlides();
    this.initEmbla();
  }

  disconnect() {
    this.stopAutoplay();
    this.element.removeEventListener("mouseenter", this._stopAutoplay);
    this.element.removeEventListener("mouseleave", this._startAutoplay);
    this.embla?.destroy();
    this.embla = null;
  }

  duplicateSlides() {
    const slides = Array.from(this.container.children);
    slides.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.dataset.cgwmTrialClone = "true";
      this.container.appendChild(clone);
    });
  }

  initEmbla() {
    this.embla = EmblaCarousel(this.element, {
      loop: true,
      align: "start",
      slidesToScroll: 1,
      dragFree: false,
      duration: 45000,
    });

    this._onAutoplayTick = () => {
      if (!this.embla) return;
      this.embla.scrollNext();
    };

    this._startAutoplay = this.startAutoplay.bind(this);
    this._stopAutoplay = this.stopAutoplay.bind(this);
    this._resetAutoplay = this.resetAutoplay.bind(this);

    this._onInit = () => {
      this.stopAutoplay();
      requestAnimationFrame(() => {
        if (!this.embla || this.embla.scrollSnapList().length < 2) return;
        this.startAutoplay();
      });
    };

    this.embla.on("init", this._onInit);
    this.embla.on("reInit", this._onInit);
    this.embla.on("pointerDown", this._resetAutoplay);

    this.element.addEventListener("mouseenter", this._stopAutoplay);
    this.element.addEventListener("mouseleave", this._startAutoplay);

    this.container.querySelectorAll("img").forEach((img) => {
      if (!img.complete) {
        img.addEventListener("load", () => this.embla?.reInit(), { once: true });
      }
    });

    this.embla.reInit();
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayTimer = window.setInterval(this._onAutoplayTick, this.delayValue);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      window.clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  resetAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }
}
